// extracted by mini-css-extract-plugin
export default {"item":"Item_item","notOwn":"Item_notOwn","isUnique":"Item_isUnique","isRare":"Item_isRare","nationWrapper":"Item_nationWrapper","nationIcon":"Item_nationIcon"};